const initialState = () => ({
  activeId: null,
  content: [],
  resolvedAt: null
});

export default function(type, attrs = {}, options = {}) {
  return {
    namespaced: true,
    state: initialState(),
    getters: {
      active: (state, getters) => {
        return getters.findOrCreate(state.activeId);
      },
      findOrCreate: (state, getters) => id => {
        return id === "new" ? getters.create() : getters.find(id);
      },
      find: state => id => {
        if (!id) return;
        return state.content.find(item => item.id === id.toString());
      },
      create: () => () => ({
        type,
        ...attrs
      }),
      serialize: () => payload => {
        let json = {};

        Object.keys(attrs).forEach(key => (json[key] = payload[key]));

        if (payload.included) {
          json.included = payload.included;
        }

        return json;
      }
    },
    mutations: {
      activate(state, id) {
        state.activeId = id;
      },
      clear(state) {
        const s = initialState();
        Object.keys(s).forEach(key => {
          state[key] = s[key];
        });
      }
    },
    actions: {
      findAll({ dispatch }, payload) {
        const parent = options.parentType
          ? { type: options.parentType, id: payload[options.parentKey] }
          : null;
        dispatch(
          "fetchResources",
          {
            parent,
            type,
            pathName: options.pathName,
            query: options.query
          },
          { root: true }
        );
      },
      async save({ dispatch, getters }, payload) {
        const parent = options.parentType
          ? { type: options.parentType, id: payload[options.parentKey] }
          : null;
        await dispatch(
          "saveResource",
          {
            parent,
            type: options.pathName || type,
            id: payload.id,
            body: getters.serialize(payload),
            query: payload.query
          },
          { root: true }
        );
      },
      async delete({ dispatch }, id) {
        await dispatch(
          "deleteResource",
          {
            type,
            id,
            pathName: options.pathName
          },
          { root: true }
        );
      }
    }
  };
}
